import { HTTP } from '../../http';

const state = {
  currentBatteries: JSON.parse(localStorage.getItem('exideBatteries')) || null,
  currentBatteriesErrors: false
};

const mutations = {
  SET_CURRENT_BATTERIES(state, data) {
    state.currentBatteries = data;
    localStorage.setItem('exideBatteries', JSON.stringify(data));
  },
  SET_CURRENT_BATTERIES_ERRORS(state, data) {
    state.currentBatteriesErrors = data;
  }
};

const getters = {
  getCurrentBatteries: state => state.currentBatteries,
  getCurrentBatteriesErrors: state => state.currentBatteriesErrors
};

const actions = {
  getBatteriesData: ({ commit }, payload) => {
    commit('SET_CURRENT_BATTERIES_ERRORS', null);

    return HTTP.post('/api/find-batteries', {
      vehicleDataId: payload
    }).then(response => {
        commit('SET_CURRENT_BATTERIES', response.data.batteries);
        return response;
      })
      .catch(error => {
        commit('SET_CURRENT_BATTERIES_ERRORS', error.response.data.errors);
        throw error.response;
      });
  },
  getBatteriesDataByCarDetails: (
    { commit },
    { manufacturerId, modelId, vehicleId, vehicleType, clientId }
  ) => {
    return HTTP.post('/api/manual-search/batteries', {
      manufacturerId,
      modelId,
      vehicleId,
      vehicleType,
      clientId
    })
      .then(response => {
        if (response.data && response.data) {
          commit('SET_CURRENT_BATTERIES', response.data);
        }
        return response;
      })
      .catch(error => {
        commit('SET_CURRENT_BATTERIES_ERRORS', error.response.data.errors);
        throw error.response;
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
